(() => {
  'use strict';

  function selectRecommendations(candidates, cart, threshold, shippingEligible, giftFallback = false) {
    if (!cart || !cart.item_count) return {mode: 'family', gap: null, items: []};
    const existing = new Set((cart.items || []).map(item => String(item.product_id)));
    const pool = candidates.filter(item => item.available && !existing.has(String(item.id)) && Number.isFinite(item.price));
    if (giftFallback) {
      const used = new Set();
      const items = [];
      ['mug', 'book', 'sack'].forEach(category => {
        const item = pool.find(candidate => candidate.giftCategory === category && !used.has(String(candidate.id)));
        if (!item) return;
        used.add(String(item.id));
        items.push({...item, slot: 'gift-' + category, gapEstimate: false});
      });
      return {mode: 'gift', gap: null, items};
    }
    const shippingMode = shippingEligible === true && cart.currency === 'AUD' && cart.requires_shipping && Number.isFinite(cart.total_price) && Number.isFinite(threshold) && threshold > cart.total_price;
    const gap = shippingMode ? threshold - cart.total_price : null;
    const socks = pool.find(item => item.handle === 'festive-gingerbread-socks');
    const selected = [];
    const used = new Set();
    const remaining = () => pool.filter(item => !used.has(String(item.id)) && item !== socks);
    const relevant = choices => choices.find(item => item.matching) || choices[0];
    const add = (item, slot, gapEstimate = false) => {
      if (!item || used.has(String(item.id))) return;
      used.add(String(item.id));
      selected.push({...item, slot, gapEstimate});
    };
    // Reserve socks for the third slot; use the verified family order for the first.
    add(relevant(remaining()), 'matching');
    let gapItem;
    if (shippingMode) {
      const choices = remaining();
      const maximumExtra = Math.max(2000, Math.round(gap * 0.5));
      gapItem = choices.filter(item => item.price >= gap && item.price - gap <= maximumExtra)
        .sort((a, b) => a.price - b.price || Number(b.matching) - Number(a.matching))[0];
      if (!gapItem) gapItem = choices.filter(item => item.price < gap)
        .sort((a, b) => b.price - a.price || Number(b.matching) - Number(a.matching))[0];
    }
    add(gapItem || relevant(remaining()), 'gap', !!gapItem);
    add(socks || relevant(remaining()), 'socks');
    return {mode: shippingMode ? 'shipping' : 'family', gap, items: selected};
  }

  const configElement = document.getElementById('pjau-addons-config');
  if (!configElement || window.pjauCartSuggestionsInstalled) return;
  const config = JSON.parse(configElement.textContent);
  window.pjauCartSuggestionsInstalled = true;
  let cart = config.cart;
  let revision = 0;
  let controller;
  let mutationPending = false;
  const money = cents => 'A$' + (cents / 100).toFixed(2);
  const section = () => document.querySelector('[data-pjau-cart-addons]');
  const productKey = items => [...new Set((items || []).map(item => String(item.product_id)))].sort().join('|');
  const cartKey = value => value ? JSON.stringify([value.currency, value.total_price, value.item_count, (value.items || []).map(item => [item.product_id, item.quantity])]) : '';
  let lastKey = cartKey(cart);

  function announce(message) {
    const node = document.querySelector('[data-pjau-cart-status]');
    if (node) node.textContent = message;
  }

  function syncHeaderCount() {
    if (!cart || !Number.isInteger(cart.item_count) || cart.item_count < 0) return;
    document.querySelectorAll('#pageheader .cart-link__icon').forEach(icon => {
      let badge = icon.querySelector('.cart-link__count');
      if (cart.item_count === 0) {
        if (badge) badge.remove();
        return;
      }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cart-link__count';
        icon.append(badge);
      }
      const count = String(cart.item_count);
      if (badge.textContent !== count) badge.textContent = count;
    });
  }

  function render() {
    syncHeaderCount();
    const root = section();
    if (!root) return;
    const poolKey = [...new Set(root.dataset.cartProducts.split('|').filter(Boolean))].sort().join('|');
    if (!cart || root.dataset.cartCurrency !== cart.currency || poolKey !== productKey(cart.items)) {
      root.hidden = true;
      return;
    }
    const nodes = [...root.querySelectorAll('[data-pjau-addon-card]')];
    const candidates = nodes.map(node => ({id: node.dataset.productId, handle: node.dataset.productHandle, sourceOrder: Number(node.dataset.sourceOrder), price: Number(node.dataset.priceMin), matching: node.dataset.matching === 'true', giftCategory: node.dataset.giftCategory || '', available: true, node})).sort((a, b) => a.sourceOrder - b.sourceOrder);
    const selection = selectRecommendations(candidates, cart, config.thresholdCents, config.shippingEligible === true, root.dataset.giftFallback === 'true');
    const chosen = selection.items;
    const shippingMode = selection.mode === 'shipping';
    root.dataset.mode = selection.mode;
    root.querySelector('h2').textContent = selection.mode === 'gift' ? config.giftHeading : config.shippingHeading;
    root.querySelector('.pjau-cart-addons__intro').textContent = selection.mode === 'gift' ? config.giftIntro : config.familyIntro;
    root.querySelector('.pjau-cart-addons__note').hidden = !chosen.some(item => item.gapEstimate);
    const selectedIds = new Set(chosen.map(item => item.id));
    const gap = selection.gap;
    nodes.forEach(node => {
      node.hidden = !selectedIds.has(node.dataset.productId);
      const estimate = node.querySelector('[data-pjau-addon-estimate]');
      const selected = chosen.find(item => String(item.id) === node.dataset.productId);
      node.dataset.slot = selected ? selected.slot : '';
      estimate.hidden = !(selected && selected.gapEstimate);
      estimate.textContent = selected && selected.gapEstimate ? (selected.price >= gap ? config.coversGap.replace('__AMOUNT__', money(gap)) : config.short.replace('__AMOUNT__', money(gap - selected.price))) : '';
      const button = node.querySelector('[data-pjau-addon-add]');
      if (button) button.disabled = mutationPending;
    });
    const grid = root.querySelector('.pjau-cart-addons__grid');
    chosen.forEach((item, index) => { item.node.style.order = index; grid.append(item.node); });
    root.dataset.visibleCount = String(chosen.length);
    root.hidden = chosen.length === 0;
  }

  async function getSection(signal) {
    const response = await fetch(config.sectionUrl, {credentials: 'same-origin', cache: 'no-store', signal});
    if (!response.ok) throw new Error('Cart section unavailable');
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  }

  async function refreshCandidates() {
    const current = ++revision;
    if (controller) controller.abort();
    controller = new AbortController();
    try {
      const next = await getSection(controller.signal);
      if (current !== revision) return;
      const replacement = next.querySelector('[data-pjau-cart-addons]');
      const currentSection = section();
      if (currentSection && replacement) currentSection.replaceWith(replacement);
      render();
    } catch (error) {
      if (error.name !== 'AbortError' && current === revision) {
        const currentSection = section();
        if (currentSection) currentSection.hidden = true;
      }
    }
  }

  async function refreshCart() {
    const response = await fetch(config.cartUrl, {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
    if (!response.ok) throw new Error('Cart unavailable');
    const nextCart = await response.json();
    const next = await getSection();
    const container = document.querySelector('[data-section-type="cart-template"]');
    const replacement = next.querySelector('[data-section-type="cart-template"]');
    if (!container || !replacement) throw new Error('Cart section missing');
    ++revision;
    if (controller) controller.abort();
    if (window.theme && theme.CartTemplateSection) theme.CartTemplateSection.onSectionUnload(container);
    container.innerHTML = replacement.innerHTML;
    if (window.theme && theme.CartTemplateSection) theme.CartTemplateSection.onSectionLoad(container);
    cart = nextCart;
    lastKey = cartKey(cart);
    render();
    document.dispatchEvent(new CustomEvent('cart:updated'));
    const heading = container.querySelector('h1');
    if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({preventScroll: true}); }
  }

  async function mutate(url, payload, button) {
    if (mutationPending) return;
    mutationPending = true;
    const label = button && button.textContent;
    if (button) { button.disabled = true; button.textContent = config.adding; }
    render();
    let completed = false;
    try {
      const response = await fetch(url, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(payload)});
      if (!response.ok) {
        const error = await response.json().catch(() => null);
        throw new Error(error && error.description || config.addError);
      }
      completed = true;
      await refreshCart();
      announce(button ? config.added : config.removed);
    } catch (error) {
      announce(completed ? config.refreshError : error.message || config.addError);
    } finally {
      mutationPending = false;
      if (button && button.isConnected) { button.disabled = false; button.textContent = label; }
      render();
    }
  }

  document.addEventListener('pjau:cart-refreshed', event => {
    cart = event.detail.cart;
    render();
    const key = cartKey(cart);
    if (key !== lastKey && !mutationPending) {
      lastKey = key;
      if (cart) refreshCandidates();
    }
  });

  // Other destinations still receive family matches, without loading shipping claims.
  if (!config.shippingEligible) {
    let refreshTimer;
    let cartRevision = 0;
    const syncFamilyCart = async () => {
      const current = ++cartRevision;
      try {
        const response = await fetch(config.cartUrl, {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
        if (!response.ok) throw new Error('Cart unavailable');
        const nextCart = await response.json();
        if (current !== cartRevision) return;
        cart = nextCart;
        render();
        const key = cartKey(cart);
        if (key !== lastKey && !mutationPending) {
          lastKey = key;
          refreshCandidates();
        }
      } catch (error) {
        if (current === cartRevision) {
          const root = section();
          if (root) root.hidden = true;
        }
      }
    };
    const scheduleFamilyRefresh = () => { clearTimeout(refreshTimer); refreshTimer = setTimeout(syncFamilyCart, 150); };
    if (window.jQuery) {
      window.jQuery(document).on('ajaxSuccess.pjauFamilySuggestions', (event, xhr, options) => {
        if (/\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/.test(options.url || '')) scheduleFamilyRefresh();
      });
    }
    ['cart:updated', 'cart:refresh', 'cart:change'].forEach(name => document.addEventListener(name, scheduleFamilyRefresh));
    window.addEventListener('pageshow', scheduleFamilyRefresh);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) scheduleFamilyRefresh(); });
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-pjau-addon-add]');
    if (button && button.closest('[data-pjau-cart-addons]')) {
      event.preventDefault();
      if (!button.disabled && !button.closest('[data-pjau-addon-card]').hidden) mutate(config.addUrl, {items: [{id: Number(button.dataset.variantId), quantity: 1}]}, button);
      return;
    }
    const remove = event.target.closest('[data-pjau-cart-layout] #cartform a.remove');
    if (!remove || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(remove.href, location.href);
    const line = Number(url.searchParams.get('line'));
    if (!Number.isInteger(line) || line < 1 || url.searchParams.get('quantity') !== '0') return;
    event.preventDefault();
    mutate(config.changeUrl, {line, quantity: 0});
  });

  render();
})();

